import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { HxAuthService, Notification, NotifierService } from 'hx-services';
import { HxPagedListDirective } from 'hx-components';
import { TranslocoDirective } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { DatePipe, NgFor } from '@angular/common';

interface ListFilter {
  name: string;
  options: { label: string, value: string | number, checked?: boolean }[];
  isVisible: boolean;
  isActive: boolean;
  operator: 'and' | 'or';
}

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications-page.component.html',
    styleUrls: ['./notifications-page.component.less'],
    imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, DatePipe]
})
export class NotificationsPage extends HxPagedListDirective<Notification> implements OnInit {
  isLoading: {
    notifications: Map<number, boolean>
  } = {
    notifications: new Map<number, boolean>()
  };
  private readonly address = 'notifications';

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    private notifierService: NotifierService,
    private auth: HxAuthService,
  ) {
    super(router, aRoute);
  }

  ngOnInit() {
    // this.notifierService
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        const asNumberFn = (name: string, def?: number) => paramMap.get(name) ? Number(paramMap.get(name)) : def;
        // const asBooleanFn = (name: string, def?: boolean) => paramMap.get(name) ? paramMap.get(name) === 'true' : def;
        super.load(paramMap);
      });
  }

  resetFilter(filter: ListFilter) {
    filter.options.forEach(op => op.checked = false);
  }

  applyFilters() {
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: {},
      queryParamsHandling: 'merge',
    });
  }

  applyFilter(filter: ListFilter) {
    const checkedArr = filter.options.filter(v => v.checked).map(v => v.value);
    let filterParam: string | null = null;
    let filterOp: 'and' | 'or' | null = null;
    if (checkedArr.length !== 0) {
      filterParam = checkedArr.join(',');
      filterOp = filter.operator;
    }
    const queryParams: Params = {};
    queryParams[filter.name] = filterParam;
    queryParams[filter.name + '_op'] = filterOp;
    filter.isVisible = false;
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }

  protected async loadList() {
    return this.notifierService.send(this.address, {}, {
      username: this.auth.user.phone, action: 'getMessages'
    });
  }
}
